document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.collection-tabs-wrapper').forEach(function (wrapper) {
    var tabButtons = wrapper.querySelectorAll('.collection-tab-btn');
    var panels = wrapper.querySelectorAll('.collection-tab-panel');

    tabButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-tab');

        tabButtons.forEach(function (b) {
          b.classList.remove('active');
          b.setAttribute('aria-selected', 'false');
        });
        btn.classList.add('active');
        btn.setAttribute('aria-selected', 'true');

        panels.forEach(function (panel) {
          if (panel.getAttribute('data-panel') === target) {
            panel.classList.add('active');
          } else {
            panel.classList.remove('active');
          }
        });
      });
    });

    var faqItems = wrapper.querySelectorAll('.collection-faq-item');
    faqItems.forEach(function (item) {
      var question = item.querySelector('.collection-faq-question');
      var answer = item.querySelector('.collection-faq-answer');
      var inner = item.querySelector('.collection-faq-answer-inner');

      question.addEventListener('click', function () {
        var isOpen = item.classList.contains('open');

        if (isOpen) {
          item.classList.remove('open');
          answer.style.maxHeight = null;
        } else {
          item.classList.add('open');
          answer.style.maxHeight = inner.scrollHeight + 20 + 'px';
        }
      });
    });
  });
});